// Apparence claire / sombre appliquée aux tokens AVANT tout autre module (theme/colorMode.js).
import './theme/colorMode';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { loadClubPublicConfig } from './services/clubPublicConfig';
import { LEAGUE_SPACE, getPlatformSpace } from './services/platformSpace';

// Pas de <React.StrictMode> : en développement il rend chaque composant deux fois et lance chaque
// effet deux fois (appels API et connexions SignalR doublés à chaque changement de page), ce qui
// rendait la navigation de l'ERP nettement moins fluide. Sans effet sur le build de production.
// Configuration publique du club (marque, nom, modules) : espace club seulement — l'espace Ligue n'a pas de club.
if (getPlatformSpace() !== LEAGUE_SPACE) void loadClubPublicConfig();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
